import { Button, Switch } from "antd";
import React from "react";
import { CaptureController } from "../../../Controller/3DController/Captuire/CaptureController";
import { CameraContainer, CameraContainerColumn, CaptureToolMenuContainer, CaptureToolMenuFunctionButtonContainer, CaptureToolSectionContainer } from "../../CaptureTool-styled";


export interface Props {
  captureController:CaptureController;
}

export interface State {
}

export class CaptureToolMenu extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  public onTestAnimationButtonClick = () => {
    const { cameraManager } = this.props.captureController;
    if (cameraManager.animationActive) {
      this._abortAnimationAndVideo();
    } else {
      cameraManager.playAnimation();
    }
  }

  public onVideoButtonClick = () => {
    const { captureController } = this.props;
    const { cameraManager } = captureController;
    if (cameraManager.animationActive) {
      this._abortAnimationAndVideo();
    } else {
      cameraManager.playAnimation();
      captureController.recordVideo();
    }
  }

  private _abortAnimationAndVideo = () => {
    const { captureController } = this.props;
    const { cameraManager } = captureController;
    captureController.abortVideo();
    cameraManager.stopAnimation();
  }

  public render = () => {
    const { captureController } = this.props;
    const { 
      cameraManager,
      takeScreenshot,
      saveCaptureConfiguration,
      lastSavedConfigLink,
      canvasWidth, 
      setCanvasWidth, 
      canvasHeight, 
      setCanvasHeight,
      videoLength,
      setVideoLength,
      videoFps,
      setVideoFps,
      videoBitrate,
      setVideoBitrate,
      backgroundActive,
      setBackgroundActive,
      reflectionActive,
      setReflectionActive,
      shadowActive,
      setShadowActive,
      logoActive,
      setLogoActive,
      backgroundColor,
      setBackgroundColor,
      reflectionPlaneRadius,
      setReflectionPlaneRadius,
      ringRotation,
      setRingRotation
    } = captureController;

    const { cameras } = cameraManager;

    return (
      <React.Fragment>
        <CaptureToolMenuContainer>

          {lastSavedConfigLink && 
            <CaptureToolSectionContainer>
              <React.Fragment>
                <div><strong>Config link:</strong></div>
                <div>{lastSavedConfigLink}</div>
              </React.Fragment>
           </CaptureToolSectionContainer>
          }
          
          <CaptureToolSectionContainer>
            <div><strong>General settings:</strong></div>
            Width: 
            <input type='number' 
              value={canvasWidth}
              onChange={(e) => { setCanvasWidth(Number(e.target.value)) }}
            />
            px
            <br/>

            Height: 
            <input type='number' 
              value={canvasHeight}
              onChange={(e) => { setCanvasHeight(Number(e.target.value)) }}
            />
            px
            <br/>

            <Switch
              checked={backgroundActive}
              onClick={(value) => setBackgroundActive(value)}
            />
            <span>Background </span>
            <input type="color" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)}/>
            <br/>

            <Switch
              checked={reflectionActive}
              onClick={(value) => setReflectionActive(value)}
            />
            Reflection
            <br/>

            <Switch
              checked={shadowActive}
              onClick={(value) => setShadowActive(value)}
            />
            Shadow
            <br/>
            
            <Switch
              checked={logoActive}
              onClick={(value) => setLogoActive(value)}
            />
            Logo
            <br/>

            Refl. plane radius: 
            <input type='number'
              min={0.01}
              max={1}
              step={0.005}
              value={reflectionPlaneRadius}
              onChange={(e) => { setReflectionPlaneRadius(Number(e.target.value)) }}
            />
            m
            <br/>
          </CaptureToolSectionContainer>

          <CaptureToolSectionContainer>
            <div><strong>Video settings:</strong></div>
            Length (ms):
            <input type='number' step={100} min={1000} max={100000}
              value={videoLength}
              onChange={(e) => { setVideoLength(Number(e.target.value)) }}
            />
            <br/>

            FPS:
            <input type='number' step={1} min={1} max={120}
              value={videoFps}
              onChange={(e) => { setVideoFps(Number(e.target.value)) }}
            />
            <br/>

            Bitrate:
            <input type='number' step={1000} min={1000} max={1000000000}
              value={videoBitrate}
              onChange={(e) => { setVideoBitrate(Number(e.target.value)) }}
            />
          </CaptureToolSectionContainer>

          <CaptureToolSectionContainer>
            <div><strong>Ring settings:</strong></div>
            Rotation X: 
            <input type='number'
              value={ringRotation[0]}
              onChange={(e) => { setRingRotation([Number(e.target.value), ringRotation[1], ringRotation[2]]) }}
            />
            <br/>

            Rotation Y: 
            <input type='number'
              value={ringRotation[1]}
              onChange={(e) => { setRingRotation([ringRotation[0], Number(e.target.value), ringRotation[2]]) }}
            />
            <br/>

            Rotation Z: 
            <input type='number'
              value={ringRotation[2]}
              onChange={(e) => { setRingRotation([ringRotation[0], ringRotation[1], Number(e.target.value)]) }}
            />
            <br/>
          </CaptureToolSectionContainer>

          <CaptureToolSectionContainer>
            <div><strong>Animation:</strong></div>
            {cameras.map((camera, ind) => {
              return (
                <CameraContainer 
                  isSelected={camera === cameraManager.selectedCamera}
                  key={`camera-${ind}`}
                >
                  <CameraContainerColumn>
                    <div>
                      X:
                      <input type='number' step={0.001}
                        value={camera.position[0]}
                        onChange={(e) => {
                          camera.position[0] = Number(e.target.value);
                          cameraManager.changeCameraPosition(camera, camera.position)}
                        }
                      />
                    </div>
                    <div>
                      Y:
                      <input type='number' step={0.001}
                        value={camera.position[1]}
                        onChange={(e) => {
                          camera.position[1] = Number(e.target.value);
                          cameraManager.changeCameraPosition(camera, camera.position)}
                        }
                      />
                    </div>
                    <div>
                      Z:
                      <input type='number' step={0.001}
                        value={camera.position[2]}
                        onChange={(e) => {
                          camera.position[2] = Number(e.target.value);
                          cameraManager.changeCameraPosition(camera, camera.position)}
                        }
                      />
                    </div>
                    <div>
                      Time (ms):
                      <input type='number' step={1}
                        disabled={ind === 0}  
                        value={ind === 0 ? 0 : camera.transitionTime} //Transition time for first camera is always instant
                        onChange={(e) => { cameraManager.changeCameraTransitionTime(camera, Number(e.target.value)) }}
                      />
                    </div>
                    <div>
                      Easing:
                      <select onChange={(e) => { cameraManager.changeCameraTransitionEasing(camera, e.target.value) }} disabled={ind === 0}>
                        <option value={"linear"}>Linear</option>
                        <option value={"quadratic"}>Ease</option>
                        <option value={"quadratic_in"}>Ease In</option>
                        <option value={"quadratic_out"}>Ease Out</option>
                      </select>
                    </div>
                  </CameraContainerColumn>
                  <CameraContainerColumn>
                    <div>
                      <button onClick={(e) => { cameraManager.changeSelectedCamera(camera) }}>Select</button>
                    </div>
                    <div>
                      <button onClick={(e) => { cameraManager.changeCameraPosition(camera, cameraManager.getCurrentSceneCameraPosition()) }}>Grab position</button>
                    </div>
                    <br/>
                    <div>Doubleclick to</div>
                    <div>
                      <button onDoubleClick={(e) => { cameraManager.deleteCamera(camera) }} disabled={ind === 0}>Delete</button>
                    </div>
                  </CameraContainerColumn>
                </CameraContainer>
              )
            })}

            <button onClick={(e) => { cameraManager.createNewCamera() }}>Add camera</button>
          </CaptureToolSectionContainer>

          <CaptureToolMenuFunctionButtonContainer>
            <Button 
              type="primary" 
              block
              onClick={(e) => takeScreenshot(true)}
            >
              SCREENSHOT
            </Button>
            <br/>
            <Button 
              type="primary"
              danger={cameraManager.animationActive}
              block
              onClick={this.onVideoButtonClick}
            >
              {cameraManager.animationActive ? 'ABORT' : 'VIDEO'}
            </Button>
            <br/>
            <Button 
              type="primary"
              danger={cameraManager.animationActive}
              block
              onClick={this.onTestAnimationButtonClick}
            >
              {cameraManager.animationActive ? 'ABORT' : 'TEST ANIMATION'}
            </Button>
            <br/>
            <Button 
              type="primary" 
              block
              onClick={() => saveCaptureConfiguration()}
            >
              SAVE CONFIG
            </Button>
            <br/>
            <Button 
              type="primary" 
              block
              onClick={() => saveCaptureConfiguration(true)}
            >
              SAVE CONFIG + RING
            </Button>
          </CaptureToolMenuFunctionButtonContainer>

        </CaptureToolMenuContainer>
      </React.Fragment>
    )
  }

}//class